import { SPLITTER } from './constants';
var replacerPlusAndAmpersandForValidQueryString = function replacerPlusAndAmpersandForValidQueryString(str) {
  return str.replaceAll(", ", SPLITTER).replaceAll(" ", "+").replaceAll("&", "%26");
};
export { replacerPlusAndAmpersandForValidQueryString };